import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchema = Yup.object().shape({
  viTri: Yup.object()
    .shape({
      value: Yup.number()
    })
    .nullable(VALIDATE_MESSAGE.required)
    .required(VALIDATE_MESSAGE.required)
});
